import './RefProgram.css';
import { IcoLeadership } from '../../../../components/svg/IcoLeadership';
import { IcoStarHalf } from '../../../../components/svg/IcoStarHalf';
import { CircleWithDot } from '../../../../components/svg/CircleWithDot';
import { IcoCopy } from '../../../../components/svg/IcoCopy';
import { useState } from 'react';

export const RefProgram = () => {
    const [refLink, setRefLink] = useState('https://csgetto.cash/gift/hYYsdzLwwnaI2jOF');

    return (
        <div className="ref-program">
            <button className="ref-program__button-details">Подробнее</button>
            <div className="ref-program__container">
                <h2 className="ref-program__title">Реферальная программа</h2>
                <div className="ref-program__ref-info">
                    {refLink}
                    <IcoCopy refLink={refLink} />
                </div>
                <div className="ref-program__info-container">
                    <div className="ref-program__info-block">
                        <span className="ref-program__block-title">Доход со ставок</span>
                        <span className="ref-program__block-info">15 067.00 р.</span>
                    </div>
                    <div className="ref-program__info-block">
                        <span className="ref-program__block-title">Доход c депозитов</span>
                        <span className="ref-program__block-info">15 067.00 р.</span>
                    </div>
                    <div className="ref-program__info-block">
                        <span className="ref-program__block-title">Начисленно</span>
                        <span className="ref-program__block-info">145.00 р.</span>
                    </div>
                </div>
            </div>
            <div className="ref-program__vertical-border"></div>
            <div className="ref-program__container">
                <CircleWithDot />
                <div className="ref-program__block-bonus">
                    <div className="ref-program__block-bonus-svg">
                        <IcoLeadership />
                        <span className="ref-program__block-bonus-text">Приглашено</span>
                        <span className="ref-program__block-bonus-result">17</span>
                    </div>
                    <div className="ref-program__block-bonus-svg">
                        <IcoStarHalf />
                        <span className="ref-program__block-bonus-text">Бонус</span>
                        <span className="ref-program__block-bonus-result">1%</span>
                    </div>
                    <div className="ref-program__block-bonus-svg">
                        <IcoStarHalf />
                        <span className="ref-program__block-bonus-text">До след. уровня</span>
                        <span className="ref-program__block-bonus-result">0 р./ 13 983 р.</span>
                    </div>
                </div>
            </div>
        </div>
    );
};
